module.exports = __webpack_public_path__ + "static/media/franchisee-off.6e92cda7.svg";